import React, { useState } from 'react';
import EskaintzaVideosBlockView from './EskaintzaVideosBlockView';
const EskaintzaVideosBlockEdit = (props) => {
    // eslint-disable-next-line no-unused-vars
    const [selectedItemBlock, setSelectedItemBlock] = useState(-1);
    return (
        <>
            <div
                className="eskaintza-related-videos"
                onClick={() => {
                    props.setSidebarTab(1);
                    setSelectedItemBlock(-1);
                }}
                aria-hidden="true"
            ></div>
            <EskaintzaVideosBlockView
                {...props}
                isEditMode={true}
            ></EskaintzaVideosBlockView>
        </>
    );
};

export default EskaintzaVideosBlockEdit;
